<script setup lang="ts">
/**
 * Redirect: el reporte de ventas vivía acá antes de §31, cuando "Reports" era el
 * menú padre. Ahora el padre es "Sales" y este es uno de sus dos hijos.
 *
 * Se deja la ruta viva en vez de borrarla: es una pantalla que la gente marca
 * como favorita, y un 404 por haber reordenado un menú es una rotura gratuita.
 */
definePage({ redirect: '/sales/reports' })
</script>

<template>
  <div />
</template>
